const _fillYear = (idStr) => {
    const $yearElement = document.getElementById(idStr);
    if (!$yearElement) {
        return;
    }
    $yearElement.innerHTML = _thisYear;
}, _currentDate = new Date(), _thisYear = _currentDate.getFullYear().toString();
_fillYear('this-year');
